// What a folder still holds, for the disabled Delete item: a folder with subfolders or items in it
// has to be emptied first, and this says which.
export const folderContentsLabel = (subfolderCount = 0, itemCount = 0) =>
  [
    subfolderCount > 0 ? `${subfolderCount} ${subfolderCount === 1 ? 'folder' : 'folders'}` : null,
    itemCount > 0 ? `${itemCount} ${itemCount === 1 ? 'item' : 'items'}` : null
  ]
    .filter(Boolean)
    .join(', ')
